module.exports = __webpack_public_path__ + "img/ni.7b131ab3.svg";